import React from 'react'
import UIMessages from 'src/utils/ui-messages'

interface IGroupRideInfo {
  ondemandGridePickupRadius: number
  ondemandGrideDropoffRadius: number
  scheduledGridePickupRadius: number
  scheduledGrideDropoffRadius: number
  scheduledGridePickupTime: number
  scheduledGrideDropoffTime: number
  allowGroupingDifferentProducts: boolean
}
interface IServiceViewSuggestedLocationsProps {
  serviceId: string
  groupRideInfo: IGroupRideInfo
}

export const GroupRideSettings = (props: IServiceViewSuggestedLocationsProps) => {
  return (
    <>
      {props.groupRideInfo && (
        <div className='ml3'>
          <div className='h4 mt3 bold font-dark-grey'>Radius</div>
          <div className='h6 font-grey3 mt3'>{UIMessages.service.groupSettingLabels.ondemandPickupRadius}</div>
          <div className='mt1 h5 font-dark-grey col-4'>{props.groupRideInfo.ondemandGridePickupRadius}</div>

          <div className='h6 font-grey3 mt3'>{UIMessages.service.groupSettingLabels.ondemandDropoffRadius}</div>
          <div className='mt1 h5 font-dark-grey col-4'>{props.groupRideInfo.ondemandGrideDropoffRadius}</div>

          <div className='h6 font-grey3 mt3'>{UIMessages.service.groupSettingLabels.scheduledPickupRadius}</div>
          <div className='mt1 h5 font-dark-grey col-4'>{props.groupRideInfo.scheduledGridePickupRadius}</div>

          <div className='h6 font-grey3 mt3'>{UIMessages.service.groupSettingLabels.scheduledDropoffRadius}</div>
          <div className='mt1 h5 font-dark-grey col-4'>{props.groupRideInfo.scheduledGrideDropoffRadius}</div>

          <div className='h6 font-grey3 mt3'>{UIMessages.service.groupSettingLabels.scheduledPickupTime}</div>
          <div className='mt1 h5 font-dark-grey col-4'>{props.groupRideInfo.scheduledGridePickupTime}</div>

          <div className='h6 font-grey3 mt3'>{UIMessages.service.groupSettingLabels.scheduledDropoffTime}</div>
          <div className='mt1 h5 font-dark-grey col-4'>{props.groupRideInfo.scheduledGrideDropoffTime}</div>

          <div className='h6 font-grey3 mt3'>
            {UIMessages.service.groupSettingLabels.allowGroupingDifferentProducts}
          </div>
          <div className='mt1 h5 font-dark-grey col-4'>
            {props.groupRideInfo.allowGroupingDifferentProducts ? 'Yes' : 'No'}
          </div>
        </div>
      )}
    </>
  )
}

export default GroupRideSettings



// WEBPACK FOOTER //
// ./src/components/services/view/GroupRideSettings.tsx